// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"148":"5cc1f228c94a5ad2","1718":"b4c989d3ba8fa72e","2888":"a431c2c277772abc"}[chunkId] + ".css";
};